import { AdPlacement } from "@/components/ads/AdPlacement";
import { SciBreadcrumb, SciExplainer, SciPage } from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { MolecularWeightCalc } from "../components/MolecularWeightCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.mw_tool_name()}
        toolPath="/molecular-weight"
      />

      <header className="mt-6 mb-8">
        <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
          {m.mw_h1()}
        </h1>
        <p className="mt-3 leading-relaxed text-muted-foreground">
          {m.mw_intro()}
        </p>
      </header>

      <MolecularWeightCalc />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.mw_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.mw_ex1(), m.mw_ex2(), m.mw_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.mw_faq_q1(), a: m.mw_faq_a1() },
          { q: m.mw_faq_q2(), a: m.mw_faq_a2() },
          { q: m.mw_faq_q3(), a: m.mw_faq_a3() },
          { q: m.mw_faq_q4(), a: m.mw_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
